export default __webpack_public_path__ + "images/L4.27b6cba.png";